import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffPayments = () => import('./staff/payments')

Vue.use(Router)

// reference (access.view_reference / m_modules_permissions.reference) ->
// nombre de ruta. Fuente única, ver router/viewsRegistry.js.
const VIEWS = {
  dashboard: 'PaymentsErpStaffDashboard',
  payments: 'PaymentsErpStaffPayments',
}

const router =
  [
    {
      path: '/st/payments-erp',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: VIEWS.dashboard,
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Pagos',
          }
        },
        {
          path: 'payments',
          name: VIEWS.payments,
          component: ViewStaffPayments,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Gestión de Pagos',
          }
        },
      ]
    },

    {
      path: '/cu/payments-erp',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/payments-erp',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
export { VIEWS }
